<ion-menu contentId="main-content" side="end">
  <ion-header>
    <ion-toolbar>
      <ion-img alt="" class="brand-logo" src="assets/image/brand.png"></ion-img>
      <ion-buttons slot="end">
        <ion-menu-toggle>
          <ion-button fill="outline" color="primary">
            <ion-icon slot="icon-only" name="close"></ion-icon>
          </ion-button>
        </ion-menu-toggle>
      </ion-buttons>
    </ion-toolbar>
  </ion-header>
  <ion-content class="ion-padding">
    <ion-list lines="none">
      @for (menuItem of menu; track menuItem) {
        <ion-menu-toggle *hasAnyRoles="menuItem.roles">
          <ion-item button [routerLink]="menuItem.link" routerDirection="forward">
            <ion-icon color="primary" slot="start" [name]="menuItem.icon"></ion-icon>
            <ion-label>{{ menuItem.label | translate }}</ion-label>
          </ion-item>
        </ion-menu-toggle>
      }
      @if (this.authService.currentUser()?.userName === 'pkp_admin_test') {

        <ion-item>
          <ion-label>Logok</ion-label>
          <ion-toggle [ngModel]="devService.logsVisible()" (ionChange)="devService.toggleLogs()"></ion-toggle>
        </ion-item>
      }
    </ion-list>
  </ion-content>
</ion-menu>
